import React, {useCallback} from 'react';
import {priority} from '@priority-software/priority-proto-api/lib/nform';
import {
    ChooseDropdownContent,
    SearchDropdownContent
} from '../../../../components/Common/FieldSearch';
import {FieldSearchDropdownProps} from '../../../../components/Common/FieldSearch/types/DropdownProps';
import {StatusIcon} from '../StatusIcon';

export const DropdownContent = (
    props: FieldSearchDropdownProps & {statuses: priority.netitems.form.IStatus[]}
) => {
    const {isSearchable, hasStatus, statuses} = props;
    const statusRenderer = useCallback(
        (status: string) => <StatusIcon status={status} statuses={statuses} />,
        []
    );

    return isSearchable ? (
        <SearchDropdownContent {...props} />
    ) : (
        <ChooseDropdownContent {...props} statusRenderer={hasStatus ? statusRenderer : undefined} />
    );
};
